export class Link {
  href: string;
}
